module.exports = __webpack_public_path__ + "img/welcome-bg-img.71302c65.png";